export default "__VITE_ASSET__38fa9fb7__"